import React, { Component } from "react";
import "./BarChart.css";
import * as d3 from "d3";
import moment from "moment";
import { removeData } from "jquery";

// const d3 = window.d3;

class BarChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chartData: props.chartData || [],
      xDataType: props.xDataType || "string",
      selectedBar: props.selectedBar,
    };
  }

  componentDidMount() {
    if (this.state.chartData.length > 0) {
      this.renderGraph();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.xDataType !== prevProps.xDataType) {
      this.setState({
        xDataType: this.props.chartData,
      });
    }

    if (this.props.selectedBar !== prevProps.selectedBar) {
      this.setState(
        {
          selectedBar: this.props.selectedBar,
        },
        function () {
          if (this.state.chartData.length > 0) {
            d3.select(this.refs.barRef).html("");
            this.renderGraph();
          }
        }
      );
    }

    if (
      JSON.stringify(this.props.chartData) !==
      JSON.stringify(prevProps.chartData)
    ) {
      this.setState(
        {
          chartData: this.props.chartData || [],
        },
        function () {
          if (this.state.chartData.length > 0) {
            d3.select(this.refs.barRef).html("");
            this.renderGraph();
          }
        }
      );
    }
  }

  convertDigitToShort(value) {
    let val = parseFloat(value);
    if (val && val > 0) {
      var suffixes = ["", "K", "M", "B", "T"];
      var suffixNum = Math.floor(("" + val).length / 3);
      var shortValue = parseFloat(
        (suffixNum != 0 ? val / Math.pow(1000, suffixNum) : val).toPrecision(2)
      );
      if (shortValue < 1) {
        suffixNum = suffixNum - 1;
        shortValue = parseFloat(
          suffixNum != 0 ? val / Math.pow(1000, suffixNum) : val
        );
      }
      if (shortValue % 1 != 0) {
        if (suffixNum === 1) {
          shortValue = shortValue.toFixed(0);
        } else {
          shortValue = shortValue.toFixed(1);
        }
      }
      return shortValue + suffixes[suffixNum];

      // if (shortValue % 1 != 0) {
      //     shortValue = shortValue.toFixed(1);
      // }
      // return shortValue+suffixes[suffixNum];
    } else {
      return 0;
    }
  }

  intToReadableFormat(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  renderGraph = () => {
    // Setting Layout
    const parentThis = this;
    const margin = { top: 10, right: 30, bottom: 20, left: 30 };
    const layer = {
      width: this.refs.barRef.clientWidth - (margin.right + margin.left),
      height: this.refs.barRef.clientHeight - (margin.top + margin.bottom),
    };
    const layout = d3
      .select(this.refs.barRef)
      .append("svg")
      .style("background-color", "white")
      .attr("width", layer.width + margin.right + margin.left)
      .attr("height", layer.height + margin.top + margin.bottom);

    layout
      .append("g")
      .style("stroke-width", "1.5px")
      .style("fill", "black")
      .style("alignment-baseline", "middle")
      .attr("x", margin.left)
      .attr("y", 30)
      .attr("text-anchor", "left")
      .attr("font-family", "Poppins")
      .attr("font-size", "20px");
    const background = layout
      .append("svg")
      .style("background-color", "#fff")
      .attr("width", layer.width)
      .attr("height", layer.height)
      .attr("x", margin.left)
      .attr("y", margin.top);

    // .attr("transform", `translate(-${layer.width+margin.right -1},${margin.top})`);
    // .attr("transform", `translate(${margin.left+1},-${layer.height+margin.bottom+4})`);

    // Data Entry
    const data = this.state.chartData;
    const xDatas = data.map(function (object) {
      return object.xData; // creating array of keys
    });
    const yDataArr = data.map(function (object) {
      return object.yData; // creating array of values
    });
    let maxValue = d3.max(yDataArr); // defining max value
    if (maxValue <= 0) {
      maxValue = 5;
    }

    // Scaling Method

    // let yMax = d3.max(this.state.barData, d => {
    //     return d["yData"];
    // });

    const yScale = d3
      .scaleLinear() // projecting continuous data into the diagram
      .domain([maxValue, 0])
      // .range([0,layer.height]);
      .range([0, layer.height]);
    const xScale = d3
      .scaleBand() // projecting discrete data into the diagram
      .domain(xDatas)
      .range([0, layer.width])
      .paddingInner(0.05);

    // Axis lines and tickmarks

    const yAxis = d3
      .axisLeft(yScale)
      .ticks(5)
      .tickFormat((d) => {
        return this.convertDigitToShort(d);
      });
    const xAxis = d3.axisBottom(xScale).tickFormat((d) => {
      if (this.state.xDataType === "date") {
        return moment(parseInt(d)).format("MMM");
      } else if (this.state.xDataType === "string") {
        return d;
      } else {
        return d;
      }
    });
    const yCartesian = layout
      .append("g")
      .call(yAxis)
      .attr("transform", `translate(${margin.right},${margin.top})`);
    const xCartesian = layout
      .append("g")
      .call(xAxis)
      .attr(
        "transform",
        `translate(${margin.right},${layer.height + margin.top})`
      );

    // Drawing the bars
    const bars = background
      .selectAll("rect")
      .data(data) //insert data into bars element
      .enter()
      .append("g");
    bars
      .append("rect")
      .attr("width", 10)
      .attr("height", function (d) {
        return layer.height - yScale(d.yData);
      })
      .attr("x", function (d) {
        return xScale(d.xData) + (xScale.bandwidth() - 10) / 2;
      })
      .attr("y", function (d) {
        return yScale(d.yData);
      })
      .style("fill", function (d) {
        if (parentThis.state.xDataType === "date") {
          if (
            moment(parseInt(d.xData)).format("YYYY") != moment().format("YYYY")
          ) {
            return "#0F9CE0";
          }
          return "#1D4A62";
        } else if (parentThis.state.xDataType === "string") {
          return "#FF532F";
        } else {
          return "#1D4A62";
        }
      })
      .style("stroke-width", "0.15rem")
      .style("stroke", function (d) {
        if (parentThis.state.selectedBar === d.xData) {
          if (parentThis.state.xDataType === "date") {
            return "#FF532F";
          } else if (parentThis.state.xDataType === "string") {
            return "#0C9DDF";
          } else {
            return "#0C9DDF";
          }
        } else {
          return null;
        }
      })
      .style("cursor", "pointer")
      .on("mouseover", function () {
        tooltip.style("display", "block");
      })
      .on("mouseout", function () {
        tooltip.style("display", "none");
      })
      .on("mousemove", function (event) {
        const [x, y] = d3.pointer(event);
        tooltip
          .style("margin-left", x - 10 + "px")
          .style("margin-top", y - 347 + "px");
      })
      .on("click", function (d) {
        if (parentThis.props.actionOnClick) {
          parentThis.props.actionOnClick(d.xData);
        }
      });

    var tooltip = d3.select(this.refs.tooltipRef);

    // Prep the tooltip bits, initial display is hidden
    // var tooltip = background.append("g")
    //     .attr("class", "d3tooltip")
    //     .style("display", "none")
    //     .style("z-index", 99999999);

    // tooltip.append("rect")
    //     .attr("width", 60)
    //     .attr("height", 20)
    //     .attr("fill", "#0C9DDF")
    //     .style("color", "white")

    // tooltip.append("text")
    //     .attr("x", 30)
    //     .attr("dy", "1.2em")
    //     .style("text-anchor", "middle")
    //     .attr("font-size", "12px")
    //     .attr("font-weight", "bold")
    //     .attr("font-color", "white")
  };

  render() {
    return (
      <div className="barChartContainer">
        <div className="barChart" ref="barRef"></div>
        <div className="ss-tooltip" ref="tooltipRef">
          00
        </div>
        {/* <div className="ss-bar-select"></div> */}
      </div>
    );
  }
}

export default BarChart;
